import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import { Button, Icon, Grid } from 'semantic-ui-react'
import Add from './add';
import Edit from './edit';
import ReadCookie from '../../../functions/readcookies';

class Brand extends React.Component {

  state = {
    data: [],
    load: false,
    message: '',
    editDialog: false,
    deleteDialog: false,
    adddialog: false,
  }

  componentDidMount() {
    this.getBrand();
  }

  getBrand() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Brand Details',
      adddialog: false,
    });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'addmenu/branddetails/get.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            load: false,
            data: data
          });
        } catch (e) {
          console.log(e);
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  add() {
    this.setState({
      adddialog: true
    })
  }

  updateDatas() {
    this.getBrand();
  }

  handleClose = () => {
   this.setState({ editDialog: false, deleteDialog: false, adddialog: false });
  };

  edit(id, name) {
    this.setState({
      brand_name: name,
      id: id,
      editDialog: true,
    });
  }

  delete(id) {
    this.setState({
      deleteId: id,
      deleteDialog: true,
    });
  }

  updateData(data) {
    this.setState({
      data: data,
      editDialog: false
    })
  }

  removeBrandDetails() {
    let context = this;
    context.setState({
      load: true,
      message: 'Deleting Brand Details'
    })
    let data1 = {'id': this.state.deleteId};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/branddetails/delete.php',
      success: function(data)
      {
        context.setState({
          load: false,
          deleteDialog: false,
        })
        if (data == 1) {
          context.update(context.state.deleteId);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  update(id) {
    let data = this.state.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.setState({
      data: dele,
    })
  }

  render() {
    const { load, message, data, adddialog, editDialog, deleteDialog } = this.state;
    const { fullScreen } = this.props;
    return (
      <div style={{padding: '1%', display: this.state.brandview}}>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={13}>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={3}>
            <br/>
            {
              this.props.menuPermission.add ?
              <Button style={{display: this.state.brandedit}} fluid primary onClick={this.add.bind(this)} icon labelPosition='left'>
                <Icon name='plus' />
                Add Brand
              </Button>:''
            }
            
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
          <table width='100%' id='table'>
            <tr>
              <th id='tablehead' style={{width: '10%'}}>S.No</th>
              <th id='tablehead' style={{width: '70%'}}>Brand Name</th>
              {
                this.props.menuPermission.edit ?
                <th id='tablehead' style={{width: '10%'}}>Edit</th>:''
              }
              
            </tr>
            {data.map(row => (
              <tr id='rowselect'>
                <td style={{fontSize: 14}}>{row.sino}</td>
                <td style={{fontSize: 14}}>{row.brand_name}</td>
                {
                  this.props.menuPermission.edit ?
                  <td onClick={this.edit.bind(this, row.id, row.brand_name)}
                      style={{cursor: 'pointer'}}>
                    <center>Edit</center>
                  </td>:''
                }
              </tr>
            ))}
          </table>
          </Grid.Column>
        </Grid>

        <Dialog fullScreen={fullScreen} open={adddialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Add Brand"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Add updateDatas={this.updateDatas.bind(this)} handleClose={this.handleClose} />
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={editDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Edit Brand Name"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Edit brand_name ={this.state.brand_name} data={this.state.data}
                    handleClose={this.handleClose} id={this.state.id}
                    updateData={this.updateData.bind(this)}/>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={deleteDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 100}}>
            {"Delete Category"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>Do you want to remove it!!</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.handleClose.bind(this)} color="secondary">
              NO
            </Buttons>
            <Buttons onClick={this.removeBrandDetails.bind(this)} color="primary" autoFocus>
              Yes
            </Buttons>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

export default Brand;
